// extracted by mini-css-extract-plugin
var _1 = "eyBon4LXgUxpFQSWKJvN";
var _2 = "eyBon4LXgUxpFQSWKJvN";
var _3 = "L1CD8WY9prwdWJXIiTOk";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "title" }
